var map = {
	"./img/vip/bdzh.svg": "f743",
	"./img/vip/czjl.svg": "9bfa",
	"./img/vip/lb.svg": "444f",
	"./img/vip/qdjf.svg": "b0ba",
	"./img/vip/wczhf.svg": "1e2d",
	"./img/vip/yhq.svg": "b123",
	"./img/vip/yjfl.svg": "a188"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4750";